export function readWebsiteVideo(file) {
  if (!file || !/\.mp4$/i.test(file.name) || file.size < 12 || file.size >= 100000000) {
    return Promise.reject(new Error("Bitte ein MP4-Video mit weniger als 100 MB auswählen."))
  }
  return new Promise((resolve, reject) => {
    const video = document.createElement("video")
    const url = URL.createObjectURL(file)
    const finish = (error) => {
      const duration = video.duration
      clearTimeout(timer)
      video.onloadedmetadata = null
      video.onerror = null
      video.removeAttribute("src")
      video.load()
      URL.revokeObjectURL(url)
      if (error) reject(error)
      else if (!Number.isFinite(duration) || duration <= 0 || duration > 60) reject(new Error("Das Header-Video darf maximal 60 Sekunden lang sein."))
      else resolve({ fileName: file.name, size: file.size, duration })
    }
    const timer = setTimeout(() => finish(new Error("Das Video konnte nicht gelesen werden. Bitte MP4 mit H.264 verwenden.")), 15000)
    video.preload = "metadata"
    video.onloadedmetadata = () => finish()
    video.onerror = () => finish(new Error("Das Video konnte nicht gelesen werden. Bitte MP4 mit H.264 verwenden."))
    video.src = url
  })
}
